module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.4939/img/callout-blobs.svg"